// fwptools/fwptools.js

import {fwptools} from "./fwptools-config";

//import buildInfo from './build-info.json';

const pathMap = new Map();
const typeMap = new Map();

const buildPathMap = (parent) => {
    Object.keys(parent)
          .forEach(key => {
              const object = parent[key];

              object.key = key;
              object.link = key;

              pathMap.set(key, object);

              if (object.type) {
                  typeMap.set(object.type, object);
              }

              if (object.children) {
                  buildPathMap(object.children);
              }
          });
};

buildPathMap(fwptools);

class Config {
    _parent;
    _object;

    constructor(parent, object) {
        this._parent = parent;
        this._object = object;
    }

    getChildren = () => {
        return this._get("children");
    };

    getComponent = () => {
        return this._get("import");
    };

    getIcon = () => {
        return this._get("icon");
    };

    getLink = () => {
        return this._get("link");
    };

    getDownloadUrl = (id) => {
        return `/transfers/download/tools/${id}`;
    };

    getMenu = () => {
        return this._get("menu", this.getText());
    };

    getParent = () => {
        const parent = this._parent._parent || null;
        return new Config(parent, this._parent);
    };

    getRbac = () => {
        return this._get("rbac");
    };

    getText = () => {
        return this._get("text");
    };

    getViewUrl = (id) => {
        return `${this.getLink()}/${id}`;
    };

    isDivider = () => {
        return this._get("divider");
    };

    isLink = () => {
        return this.getText();
    };

    isRoute = () => {
        return this.getComponent();
    }

    isSubMenu = () => {
        return this._get("submenu");
    };

    hasChildren = () => {
        return this._get("children");
    };

    hasDownload = () => {
        return this._get("hasDownload", true);
    };

    hasViewDetails = () => {
        return this._get("hasViewDetails");
    };

    _get = (key, dflt) => {
        return this._object && key in this._object ? this._object[key] : dflt;
    };
}

const read = (parent, key) => {
    const object = parent[key];

    object.key = key;
    object.link = key;

    return object;
};

//export { buildInfo };

export const menuIterator = (callback, root = fwptools) => {
    return Object.keys(root)
                 .map(key => callback(getConfigObject(key)));
};

export const routeIterator = (callback, root = fwptools) => {
    Object.keys(root)
          .map(getConfigObject)
          .map(config => {
              callback(config);
              return config;
          })
          .filter(config => config.hasChildren())
          .map(config => routeIterator(callback, config.getChildren()));
};

const getParentPath = (path) => {
    const idx = path.lastIndexOf("/");
    return (idx === 0) ? path : path.substring(0, idx);
};

export const toMonitorEndpoint = (uri) => {
    return process.env.REACT_APP_BACKEND_ACTUATOR_URL.concat("/", uri);
};

export const toMonolithEndpoint= (uri) => {
    return process.env.REACT_APP_MONOLITH_REST_URL.concat("/", uri);
};

export const toServiceEndpoint = (uri) => {
    return process.env.REACT_APP_BACKEND_REST_URL.concat("/", uri);
};

export const getConfigObject = (path) => {
    if (typeof path === "object") {
        path = typeMap.get(path.type.toLowerCase()).link;
    }

    const parent = getParentPath(path);
    return new Config(pathMap.get(parent), pathMap.get(path));
};

export const isDevelopment = () => {
    return process.env.NODE_ENV === "development";
};
